import { AnalysisAdditionalInfo } from "../../../../lib/enums";

export const prepareAnalysisStatusInformation = (dynamicAnalysis, key) => {
  const { display_status, additional_information, last_completed_on, enabled } =
    (dynamicAnalysis && dynamicAnalysis[key]) || {};

  return {
    isProcessing: ["Queued", "Processing"].includes(display_status),
    isConfigured:
      additional_information !== AnalysisAdditionalInfo.NOT_CONFIGURED,
    fileOversized:
      additional_information === AnalysisAdditionalInfo.FILE_OVERSIZED,
    neverSubmitted:
      additional_information === AnalysisAdditionalInfo.NEVER_SUBMITED,
    fileTypeSupported:
      additional_information !== AnalysisAdditionalInfo.NOT_SUPPORTED,
    last_completed_on,
    errorMessage:
      enabled && !last_completed_on
        ? display_status || additional_information
        : undefined
  };
};
